import { Component, Output, EventEmitter, Input } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { IAppState } from "../../store/state/app.state";
import { selectUserLogged } from "../../store/selectors/user.selector";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { UserService } from "../../services/user.service";
import { showAlertAction } from "../../store/actions/alert.action";
import { Router } from "@angular/router";
import { LocalStorageService } from "../../services/local-storage.service";
import { EStorageType } from "../../data-types/storage.enum";
import { TranslateService } from "@ngx-translate/core";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
@Component({
  selector: "cowing-core-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {
  @Output("loginEvent") loginEventEmitter = new EventEmitter();
  @Output("toRegister") toRegisterEventEmitter = new EventEmitter();
  @Input("hidePasswordIcon") hidePasswordIcon: string;
  @Input("showPasswordIcon") showPasswordIcon: string;
  @Input('isMobile') isMobile: boolean;
  email = "";
  password = "";
  // subscriber: Subscription;
  user$ = this._store.pipe(select(selectUserLogged));
  loginData = null;
  loginActionProgress = false;
  loginError: string = null;
  isLoading = false;
  openModal = false;
  public error: string = "";
  constructor(
    private _store: Store<IAppState>,
    private router: Router,
    private translate: TranslateService
  ) {}

  public loginForm = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email]),
    password: new FormControl(null, [Validators.required]),
  });

  ngOnInit() {}

  doLogin(event) {
    this._store.dispatch(showLoadingAction({}));
    const { email, password } = this.loginForm.value;
    const tokenFirebase: string = LocalStorageService.instance.get(EStorageType.TokenFirebase);
    UserService.instance
      .login(email, password, tokenFirebase, this.isMobile)
      .then((result) => {
        this._store.dispatch(closeLoadingAction({}));
        console.log("login result", result)
        if (this.isMobile && result.error) {
          // Invalid role for mobile
          this.error = this.translate.instant("login.wrong_login");
        } else {
          const role = LocalStorageService.instance.get(EStorageType.Role);
          if (role === "company" || role === 'company-plus' ) {
            this.router.navigate(["company-home/employees"]);
          } else if (role === "coworking") {
            this.router.navigate(["coworking-home/bookings"]);
          } else if (role === "coworker") {
            console.log(result);
            LocalStorageService.instance.set(
              EStorageType.Coworker,
              result.coworker.id
            );
            this.router.navigate(["coworker-home"]);
          } else if (role === "admin") {
            // LocalStorageService.instance.set(
            //   EStorageType.Coworker,
            //   result.coworker.id
            // );
            this.router.navigate(["backoffice"]);
          }
        }
      })
      .catch((err) => {
        console.log("Error:", err);
        this._store.dispatch(closeLoadingAction({}));
        this.error = err.data.error;
        if (err.status !== 401) {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message: this.error,
                title: this.translate.instant("login.caution"),
                type: "error",
              },
            })
          );
        }
      });
  }

  doPwdRecovery() {
    if (!this.loginForm.get("email").valid) {
      this._store.dispatch(
        showAlertAction({
          payload: {
            message: this.translate.instant("login.error"),
            title: this.translate.instant("login.caution"),
            type: "error",
          },
        })
      );
    } else {
      const { email } = this.loginForm.value;
      UserService.instance
        .requestPwdRecovery(email)
        .then(() => {
          this._store.dispatch(
            showAlertAction({
              payload: {
                message: this.translate.instant("login.success"),
                title: this.translate.instant("login.done"),
                type: "alert",
              },
            })
          );
        })
        .catch((err) => {
          this.error = err.data.error;
          if (err.status !== 401) {
            this._store.dispatch(
              showAlertAction({
                payload: {
                  message: this.error,
                  title: this.translate.instant("login.caution"),
                  type: "error",
                },
              })
            );
          }
        });
    }
  }

  get formControl() {
    return this.loginForm.controls;
  }

  ngOnDestroy() {
    // this.subscriber.unsubscribe();
  }
}
